import styled from 'styled-components'
import { Modal } from '@vtex/shoreline'

export const ModalContainer = styled(Modal)`
  width: 100%;
  max-width: 100%;
  height: 100vh;
  max-height: 100vh;
  padding: 80px;

  [data-sl-modal-container] {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`
